
export const getMasterpassCreditCardKeys = (creditCardValidationData) => {
    const masterpassCreditCards = [];
    creditCardValidationData.valueSeq().forEach((value) => {
        const masterpassKey = value.get('masterpassKey');
        if (masterpassKey) {
            masterpassCreditCards.push(masterpassKey);
        }
    });
    return masterpassCreditCards;
};

export const checkoutWithMasterpass = (masterpassData) => {
    window.masterpass.checkout(masterpassData);
};
